// 移动端适配：PC / Mobile 双模式
// PC 模式 (>= 768px)：基于 1920 设计稿等比缩放，根字体范围 10~16px
// Mobile 模式 (< 768px)：根字体固定 16px，移动端布局按 375px 设计
// postcss-pxtorem rootValue: 16，构建时 px → rem(/16)

(function () {
  const MOBILE_BREAKPOINT = 768
  const PC_DESIGN_WIDTH = 1920
  const MOBILE_DESIGN_WIDTH = 375
  const BASE_SIZE = 16
  const PC_MIN_SIZE = 10
  const PC_MAX_SIZE = 16

  function setRem() {
    const width = document.documentElement.clientWidth

    if (width >= MOBILE_BREAKPOINT) {
      // PC 模式：等比缩放
      const fontSize = Math.min(Math.max((width / PC_DESIGN_WIDTH) * BASE_SIZE, PC_MIN_SIZE), PC_MAX_SIZE)
      document.documentElement.style.fontSize = fontSize + 'px'
    } else {
      // Mobile 模式：固定 16px，移动端设计稿 375px
      const fontSize = Math.min((width / MOBILE_DESIGN_WIDTH) * BASE_SIZE, BASE_SIZE)
      document.documentElement.style.fontSize = fontSize + 'px'
    }
  }

  setRem()
  window.addEventListener('resize', setRem)
})()
